// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Mostrar contraseña',
    hide: 'Ocultar contraseña',
    copy: 'Copiar',
    copied: 'Copiado',
    once: 'Se muestra solo ahora. Cópiala y guárdala en un lugar seguro.',
  },
  loading: 'Cargando el cambio…',
  load_failed: 'No pude cargar este cambio.',
  load_retry: 'Reintentar',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: 'Este cambio se mostrará aquí cuando Amigo vuelva. No se ha modificado nada.',
    assistant: 'Este cambio se mostrará aquí cuando el asistente vuelva. No se ha modificado nada.',
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Esto ya estaba aprobado, así que no hubo nada más que hacer.',
  action_failed: 'No se completó, así que no se cambió nada. Inténtalo de nuevo en un momento.',
  removed: 'Eliminado',
  retry: 'Reintentar',
  retry_one: 'Reintentar {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Aprobado.',
    retried: 'Reintentado.',
    rejected: 'Rechazado.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Omitido en la tarjeta.',
  },
  done: {
    summary_one: 'Listo. {{count}} cambio aplicado.',
    summary_other: 'Listo. {{count}} cambios aplicados.',
    skipped_one: '{{count}} omitido, no se cambió nada.',
    skipped_other: '{{count}} omitidos, no se cambió nada.',
  },
  partial: {
    summary_one: '{{applied}} de {{approved}} cambios aplicados. {{count}} no.',
    summary_other: '{{applied}} de {{approved}} cambios aplicados. {{count}} no.',
    detail_one: 'Los {{applied}} están guardados. No se cambió nada en los {{count}} de abajo.',
    detail_other: 'Los {{applied}} están guardados. No se cambió nada en los {{count}} de abajo.',
  },
  stale: {
    summary: '{{applied}} de {{approved}} cambios aplicados.',
    detail_one: '{{count}} fue modificado por otra persona mientras tanto.',
    detail_other: '{{count}} fueron modificados por otra persona mientras tanto.',
    reason:
      '{{name}} lo cambió a {{value}} a las {{time}}, antes de que aprobaras, así que lo dejé como estaba. Aquí está de nuevo a partir del nuevo valor:',
    decided_done:
      '{{name}} lo cambió a {{value}} a las {{time}}, antes de que lo aprobaras, así que lo dejé como está. Su nueva propuesta se aprobó en su propia tarjeta.',
    decided_rejected:
      '{{name}} lo cambió a {{value}} a las {{time}}, antes de que lo aprobaras, así que lo dejé como está. Su nueva propuesta fue rechazada.',
    decided_replaced:
      '{{name}} lo cambió a {{value}} a las {{time}}, antes de que lo aprobaras, así que lo dejé como está. Su nueva propuesta fue reemplazada por una tarjeta más reciente.',
    decided_expired:
      '{{name}} lo cambió a {{value}} a las {{time}}, antes de que lo aprobaras, así que lo dejé como está. Su nueva propuesta caducó.',
  },
  undo_partly_one: '{{count}} de estos no se pueden deshacer.',
  undo_partly_other: '{{count}} de estos no se pueden deshacer.',
  undone: {
    summary_one: 'Deshecho. El {{count}} cambio vuelve a como estaba.',
    summary_other: 'Deshecho. Los {{count}} cambios vuelven a como estaban.',
    detail: 'Deshacer también queda registrado en el registro de Amigo y en Menú → Historial de ediciones.',
    partly_summary: 'Deshecho parcialmente. {{undone}} de {{count}} cambios han vuelto a su estado anterior.',
    partly_changed_one: '{{count}} fue modificado por otra persona desde entonces, así que se queda como está.',
    partly_changed_other: '{{count}} fueron modificados por otra persona desde entonces, así que se quedan como están.',
    partly_kept_one: '{{count}} ya estaba como antes.',
    partly_kept_other: '{{count}} ya estaban como antes.',
    partly_cannot_one: '{{count}} no se puede deshacer, como una eliminación, así que se queda como está.',
    partly_cannot_other: '{{count}} no se pueden deshacer, como una eliminación, así que se quedan como están.',
    partly_left_one: '{{count}} se queda como está.',
    partly_left_other: '{{count}} se quedan como están.',
  },
  summary: {
    group_one: '{{count}} plato: {{reason}}',
    group_other: '{{count}} platos: {{reason}}',
    group_names_more_one: '{{names}} y {{count}} más',
    group_names_more_other: '{{names}} y {{count}} más',
    average: '{{amount}} por plato de media',
    needs_look: 'Requiere revisión',
    nothing_else: 'No cambia nada más',
  },
  labels: {
    waiting: 'Pendiente',
    skip: 'Omitir',
    unskip: 'Deshacer omisión',
    approve_all: 'Aprobar todo',
    approve_one: 'Aprobar {{count}}',
    approve_other: 'Aprobar {{count}}',
    approve_all_count_one: 'Aprobar los {{count}}',
    approve_all_count_other: 'Aprobar los {{count}}',
    approve_row: 'Aprobar',
    reject: 'Descartar',
    reject_confirm: 'Rechazar',
    back: 'Atrás',
    why: {
      amigo: '¿Por qué no? (opcional, Amigo lo lee)',
      assistant: '¿Por qué no? (opcional, el asistente lo lee)',
    },
    hint: 'O responde abajo para cambiar algo.',
    show_all_one: 'Mostrar los {{count}} cambios',
    show_all_other: 'Mostrar los {{count}} cambios',
    show_less: 'Mostrar menos',
    applying_one: 'Aplicando {{count}} cambio…',
    applying_other: 'Aplicando {{count}} cambios…',
    high_impact: 'Alto impacto',
    done: 'Hecho',
    running: 'En curso',
    show_changes: 'Mostrar cambios',
    hide_changes: 'Ocultar cambios',
    rows: {
      skipped: 'Omitido',
      applied: 'Aplicado',
      failed: 'No aplicado',
      changed: 'Cambiado mientras tanto',
      kept: 'Se deja como está',
    },
    history: {
      amigo: 'Abrir en el registro de Amigo',
      assistant: 'Abrir en el registro del asistente',
    },
    undo: 'Deshacer',
    to: 'a',
    from: 'de',
    rejected: 'Rechazado',
    replaced: 'Reemplazado',
    expired: 'Caducado',
  },
};
